import { Button, Typography } from '@breetometer/components';
import { capitalizeFirstLetter } from 'BreetHelpers';
import { useCountDown } from 'BreetHooks';
import { useCallback } from 'react';

import type { IOTPResend } from '../helpers';

export const Resend = ({ initialCountdown, onResend, isLoading, errorMessage, cta }: IOTPResend) => {
	const { countdown, restartCountDown } = useCountDown(initialCountdown);

	const canResend = countdown === 0;

	const message = cta?.message ?? errorMessage ?? "Didn't receive code?";

	const handleOTPResend = useCallback(() => {
		onResend?.(restartCountDown);
	}, [onResend, restartCountDown]);

	const getContent = () => {
		let Component = (
			<>
				Resend in <span className='color-tertiary-400'>{countdown}s</span>
			</>
		);

		if (canResend || cta?.message) {
			Component = (
				<Button
					label={cta?.btnTitle ?? 'Resend'}
					onClick={cta?.action ?? handleOTPResend}
					type='button'
					variant='native'
					className='color-tertiary-400'
				/>
			);
		}

		if (isLoading) {
			Component = <span>Sending...</span>;
		}

		return (
			<Typography
				variant='paragraph_1'
				className='color-primary-50'
			>
				{capitalizeFirstLetter(message)} {Component}
			</Typography>
		);
	};

	return (
		<div
			className='otp_resend'
			data-testid='resend-otp'
		>
			{getContent()}
		</div>
	);
};
